export default {
  toogleLoading(state, loading) {
    state.loading = loading;
  },
  setMicroStatusLogisticProviders(state, microStatusLogisticProviders) {
    state.microStatusLogisticProviders = microStatusLogisticProviders;
  },
  setMicroStatusShipping(state, microStatusShippers) {
    state.microStatusShippers = microStatusShippers;
  },
  setFilters(state, filters) {
    state.filters = filters;
  },
};



// WEBPACK FOOTER //
// ./src/features/private/settings/pages/manage-events-micro-status/store/mutations.js